<template>
    <div>
        <br>
        <br>
        <br>
        <h1>C.I</h1>
    </div>
</template>
<script>
import {mapActions} from 'vuex'
export default{
    name: 'c-asistencial-sop-historia-ci',
    data() {
        return {
            //property: 'value',
        };
    },
    methods: {
        ...mapActions(['get', 'post']),
    },
}
</script>